var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.salvar($event)
            }
          }
        },
        [
          _c(
            "q-card",
            [
              _c(
                "q-card-main",
                [
                  _c(
                    "q-tabs",
                    {
                      attrs: { inverted: "" },
                      model: {
                        value: _vm.abaSelecionada,
                        callback: function($$v) {
                          _vm.abaSelecionada = $$v
                        },
                        expression: "abaSelecionada"
                      }
                    },
                    [
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          label: "Sistema",
                          name: "tbSistema",
                          id: "tbSistema"
                        },
                        slot: "title"
                      }),
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          label: "Relatórios",
                          name: "tbRelatorios",
                          id: "tbRelatorios"
                        },
                        slot: "title"
                      }),
                      _c("q-tab-pane", { attrs: { name: "tabProxy" } }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-input", {
                                ref: "refServidor",
                                attrs: {
                                  id: "refServidor",
                                  name: "refServidor",
                                  etiqueta: "Servidor",
                                  validacao: "text | required",
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao,
                                  tamanho: 100
                                },
                                model: {
                                  value:
                                    _vm.paginaStatus.parametrosSistema
                                      .nomServidor,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paginaStatus.parametrosSistema,
                                      "nomServidor",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paginaStatus.parametrosSistema.nomServidor"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-input", {
                                ref: "refPortaServidor",
                                attrs: {
                                  id: "refPortaServidor",
                                  name: "refPortaServidor",
                                  etiqueta: "Porta do Servidor",
                                  validacao: "number | required",
                                  mascara: "numero",
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao,
                                  tamanho: 5
                                },
                                model: {
                                  value:
                                    _vm.paginaStatus.parametrosSistema
                                      .numPortaServidor,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paginaStatus.parametrosSistema,
                                      "numPortaServidor",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paginaStatus.parametrosSistema.numPortaServidor"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-input", {
                                ref: "refNomUsuario",
                                attrs: {
                                  id: "refNomUsuario",
                                  name: "refNomUsuario",
                                  validacao: "required | text",
                                  etiqueta: "Usuário",
                                  tamanho: 100,
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao
                                },
                                model: {
                                  value:
                                    _vm.paginaStatus.parametrosSistema
                                      .nomUsuario,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paginaStatus.parametrosSistema,
                                      "nomUsuario",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paginaStatus.parametrosSistema.nomUsuario"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-input", {
                                ref: "refSenha",
                                attrs: {
                                  id: "refSenha",
                                  name: "refSenha",
                                  validacao: "required | password",
                                  tipo: "password",
                                  etiqueta: "Senha",
                                  tamanho: 50,
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao
                                },
                                model: {
                                  value:
                                    _vm.paginaStatus.parametrosSistema.txtSenha,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paginaStatus.parametrosSistema,
                                      "txtSenha",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paginaStatus.parametrosSistema.txtSenha"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row mrg-t-20" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("q-toggle", {
                                attrs: {
                                  id: "recaptcha",
                                  name: "recaptcha",
                                  label: "Usa reCAPTCHA",
                                  color: "teal-8",
                                  disable: _vm.paginaStatus.desabilitarEdicao,
                                  "true-value": "S",
                                  "false-value": "N",
                                  "checked-icon": "check",
                                  "unchecked-icon": "clear"
                                },
                                model: {
                                  value: _vm.indRecaptcha,
                                  callback: function($$v) {
                                    _vm.indRecaptcha = $$v
                                  },
                                  expression: "indRecaptcha"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _c("q-tab-pane", { attrs: { name: "tabEmail" } }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-input", {
                                ref: "refServidorEmail",
                                attrs: {
                                  id: "refServidorEmail",
                                  name: "refServidorEmail",
                                  etiqueta: "Endereço do servidor SMTP",
                                  validacao: "text | required",
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao,
                                  tamanho: 100
                                },
                                model: {
                                  value:
                                    _vm.paginaStatus.parametrosSistema
                                      .nomServidorEmail,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paginaStatus.parametrosSistema,
                                      "nomServidorEmail",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paginaStatus.parametrosSistema.nomServidorEmail"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-input", {
                                ref: "refPortaServidorEmail",
                                attrs: {
                                  id: "refPortaServidorEmail",
                                  name: "refPortaServidorEmail",
                                  etiqueta: "Nº porta do servidor SMTP",
                                  validacao: "required",
                                  mascara: "numero",
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao,
                                  tamanho: 5
                                },
                                model: {
                                  value:
                                    _vm.paginaStatus.parametrosSistema
                                      .numPortaEmail,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paginaStatus.parametrosSistema,
                                      "numPortaEmail",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paginaStatus.parametrosSistema.numPortaEmail"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-input", {
                                ref: "refTxtEmail",
                                attrs: {
                                  id: "refTxtEmail",
                                  name: "refTxtEmail",
                                  validacao: "email | required",
                                  etiqueta: "Email do servidor SMTP",
                                  foco: false,
                                  tamanho: 100,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao
                                },
                                model: {
                                  value:
                                    _vm.paginaStatus.parametrosSistema.txtEmail,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paginaStatus.parametrosSistema,
                                      "txtEmail",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paginaStatus.parametrosSistema.txtEmail"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-input", {
                                ref: "refSenhaEmail",
                                attrs: {
                                  id: "refSenhaEmail",
                                  name: "refSenhaEmail",
                                  validacao: "required | password",
                                  tipo: "password",
                                  etiqueta: "Senha do email do servidor SMTP",
                                  tamanho: 50,
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao
                                },
                                model: {
                                  value:
                                    _vm.paginaStatus.parametrosSistema
                                      .txtSenhaEmail,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paginaStatus.parametrosSistema,
                                      "txtSenhaEmail",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paginaStatus.parametrosSistema.txtSenhaEmail"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-input", {
                                ref: "refNomUsuarioEmail",
                                attrs: {
                                  id: "refNomUsuarioEmail",
                                  name: "refNomUsuarioEmail",
                                  validacao: "required | text",
                                  etiqueta:
                                    "Usuário do servidor SMTP (Caso não tenha utilize o Email)",
                                  tamanho: 100,
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao
                                },
                                model: {
                                  value:
                                    _vm.paginaStatus.parametrosSistema
                                      .nomUsuarioEmail,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paginaStatus.parametrosSistema,
                                      "nomUsuarioEmail",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paginaStatus.parametrosSistema.nomUsuarioEmail"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6 mrg-t-30" },
                            [
                              _c("q-toggle", {
                                attrs: {
                                  id: "sistemaSessao",
                                  name: "sistemaSessao",
                                  label:
                                    "Servidor de Email SMTP exige conexão segura?",
                                  color: "teal-8",
                                  disable: _vm.paginaStatus.desabilitarEdicao,
                                  "true-value": true,
                                  "false-value": false,
                                  "checked-icon": "check",
                                  "unchecked-icon": "clear"
                                },
                                model: {
                                  value:
                                    _vm.paginaStatus.parametrosSistema
                                      .conexaoSegura,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.paginaStatus.parametrosSistema,
                                      "conexaoSegura",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "paginaStatus.parametrosSistema.conexaoSegura"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-sm-6 col-xs-6" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn-email",
                                on: { click: _vm.testarEmail }
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-envelope fa-lg"
                                }),
                                _vm._v(
                                  "\n                  TESTAR\n                "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _c("q-tab-pane", { attrs: { name: "tbSistema" } }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-6 col-xs-6",
                              staticStyle: { "padding-right": "10px" }
                            },
                            [
                              _c("g-autocomplete", {
                                ref: "refCidade",
                                attrs: {
                                  id: "refCidade",
                                  name: "refCidade",
                                  etiqueta: "Cidade",
                                  valor: "codMunicipio",
                                  foco: false,
                                  validacao: "required | text",
                                  descricaoPrimaria: "nomMunicipio",
                                  api: _vm.apiCidade,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao,
                                  permitirTextoLivre: "true"
                                },
                                model: {
                                  value: _vm.codMunicipio,
                                  callback: function($$v) {
                                    _vm.codMunicipio = $$v
                                  },
                                  expression: "codMunicipio"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-sm-4 col-xs-4" },
                            [
                              _c("g-select", {
                                ref: "refUf",
                                attrs: {
                                  id: "refUf",
                                  name: "refUf",
                                  etiqueta: "UF",
                                  validacao: "required",
                                  itens: _vm.ufArray,
                                  "item-valor": "codigo",
                                  "item-etiqueta": "descricao",
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao
                                },
                                model: {
                                  value: _vm.codUf,
                                  callback: function($$v) {
                                    _vm.codUf = $$v
                                  },
                                  expression: "codUf"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-6 col-xs-6",
                              staticStyle: { "padding-right": "10px" }
                            },
                            [
                              _c("g-autocomplete", {
                                ref: "refFormaSolicitacao",
                                attrs: {
                                  id: "refFormaSolicitacao",
                                  name: "refFormaSolicitacao",
                                  etiqueta: "Forma de solicitação via Web",
                                  valor: "codFormaSolicitacao",
                                  foco: false,
                                  validacao: "required",
                                  descricaoPrimaria: "desFormaSolicitacao",
                                  api: _vm.apiformaSolicitacao,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao,
                                  permitirTextoLivre: "true"
                                },
                                model: {
                                  value: _vm.codFormaSolicitacao,
                                  callback: function($$v) {
                                    _vm.codFormaSolicitacao = $$v
                                  },
                                  expression: "codFormaSolicitacao"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("br"),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-xs-5 col-md-5" },
                            [
                              _c("g-option", {
                                ref: "refAtivo",
                                attrs: {
                                  id: "ativo",
                                  name: "ativo",
                                  tipo: "radio",
                                  option: _vm.arrayAtivoEnum,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao,
                                  etiqueta: "Obrigar telefone do requerente",
                                  validacao: "required"
                                },
                                model: {
                                  value: _vm.indTelefoneRequerente,
                                  callback: function($$v) {
                                    _vm.indTelefoneRequerente = $$v
                                  },
                                  expression: "indTelefoneRequerente"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-xs-5 col-md-5" },
                            [
                              _c("g-option", {
                                ref: "refPendencia",
                                attrs: {
                                  id: "pendencia",
                                  name: "pendencia",
                                  tipo: "radio",
                                  option: _vm.arrayAtivoEnum,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao,
                                  etiqueta:
                                    "Permitir que outros usuários alterem pendência",
                                  validacao: "required"
                                },
                                model: {
                                  value: _vm.indPendenciaProcesso,
                                  callback: function($$v) {
                                    _vm.indPendenciaProcesso = $$v
                                  },
                                  expression: "indPendenciaProcesso"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("br"),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-10 gvn-title-primary mrg-t-0" },
                            [
                              _vm._v(
                                "\n                Home page\n              "
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-xs-6 col-md-6" },
                            [
                              _c("g-option", {
                                ref: "refPermissao",
                                attrs: {
                                  id: "permissao",
                                  name: "permissao",
                                  tipo: "radio",
                                  option: _vm.arrayPermissao,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao,
                                  validacao: "required"
                                },
                                model: {
                                  value: _vm.indPermissao,
                                  callback: function($$v) {
                                    _vm.indPermissao = $$v
                                  },
                                  expression: "indPermissao"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _c("q-tab-pane", { attrs: { name: "tbRelatorios" } }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-select", {
                                ref: "refRelatorioMovimentacao",
                                attrs: {
                                  id: "refRelatorioMovimentacao",
                                  name: "refRelatorioMovimentacao",
                                  etiqueta:
                                    "Imprimir relatório na movimentação do processo?",
                                  validacao: "required",
                                  itens: _vm.arrayImpressaoMovimentacao,
                                  "item-valor": "codigo",
                                  "item-etiqueta": "descricao",
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao
                                },
                                model: {
                                  value: _vm.codImpressaoMovimentacao,
                                  callback: function($$v) {
                                    _vm.codImpressaoMovimentacao = $$v
                                  },
                                  expression: "codImpressaoMovimentacao"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-xs-6" },
                            [
                              _c("g-select", {
                                ref: "refRelatorioAbertura",
                                attrs: {
                                  id: "refRelatorioAbertura",
                                  name: "refRelatorioAbertura",
                                  etiqueta:
                                    "Imprimir relatório na abertura do processo?",
                                  validacao: "required",
                                  itens: _vm.arrayImpressaoAbertura,
                                  "item-valor": "codigo",
                                  "item-etiqueta": "descricao",
                                  foco: false,
                                  desabilitar:
                                    _vm.paginaStatus.desabilitarEdicao
                                },
                                model: {
                                  value: _vm.codImpressaoAbertura,
                                  callback: function($$v) {
                                    _vm.codImpressaoAbertura = $$v
                                  },
                                  expression: "codImpressaoAbertura"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 text-right pad-20t-h10-80b" },
        [
          _c(
            "q-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.paginaStatus.desabilitarEdicao,
                  expression: "!paginaStatus.desabilitarEdicao"
                }
              ],
              staticClass: "fixed",
              staticStyle: { right: "18px", bottom: "18px" },
              attrs: {
                id: "btnSalvar",
                name: "btnSalvar",
                round: "",
                color: "positive",
                icon: "check",
                size: "lg"
              },
              on: { click: _vm.salvar }
            },
            [_c("q-tooltip", [_vm._v("Salvar")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }